export default {
    setUserRole() {

    }
}